const ClaimDetailsSchema = {
    dateOfVehicleLoss: {
        required: { value: true, message: 'Date is required.' }
    },
    typeOfLoss: {
        required: { value: true, message: 'Please select the cause of loss.' }
    },
    odoMeter: {
        required: { value: true, message: 'Odometer is required.' },
        pattern: { value: /^[0-9]*$/, message: 'Odometer allows only numbers.' }         
    },
    claimDescription: {
        maxLength: { value: 500, message: 'Description allows up to 500 characters long.' },
        required: { value: true, message: 'Description is required.' }
    },
    question1:{
        required: { value: true, message: 'question1 is required.' }
    },
    question2:{
        required: { value: true, message: 'question1 is required.' }
    },
    question3:{
        required: { value: true, message: 'question1 is required.' }
    }
};

export default ClaimDetailsSchema;